import { Environments, isEnvironment } from './environment';

export function getApiEnvironment() {
	const apiEnv = localStorage.getItem('apiEnv');
	return isEnvironment(apiEnv)
		? (apiEnv as keyof typeof Environments)
		: undefined;
}
